/* tslint:disable */
/* eslint-disable */
/**
 * Xerjoff.Agenti.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClienteUpdateDTO
 */
export interface ClienteUpdateDTO {
    /**
     * 
     * @type {string}
     * @memberof ClienteUpdateDTO
     */
    telefono?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteUpdateDTO
     */
    mobile?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClienteUpdateDTO
     */
    email?: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClienteUpdateDTO
     */
    importoMinimoOrdine?: number;
}

/**
 * Check if a given object implements the ClienteUpdateDTO interface.
 */
export function instanceOfClienteUpdateDTO(value: object): value is ClienteUpdateDTO {
    return true;
}

export function ClienteUpdateDTOFromJSON(json: any): ClienteUpdateDTO {
    return ClienteUpdateDTOFromJSONTyped(json, false);
}

export function ClienteUpdateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClienteUpdateDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'mobile': json['mobile'] == null ? undefined : json['mobile'],
        'email': json['email'] == null ? undefined : json['email'],
        'importoMinimoOrdine': json['importoMinimoOrdine'] == null ? undefined : json['importoMinimoOrdine'],
    };
}

  export function ClienteUpdateDTOToJSON(json: any): ClienteUpdateDTO {
      return ClienteUpdateDTOToJSONTyped(json, false);
  }

  export function ClienteUpdateDTOToJSONTyped(value?: ClienteUpdateDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'telefono': value['telefono'],
        'mobile': value['mobile'],
        'email': value['email'],
        'importoMinimoOrdine': value['importoMinimoOrdine'],
    };
}

